import { contactData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
          爆料投稿与合作
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-8">
          {contactData.description}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4 md:gap-6">
          {contactData.items.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-3 bg-background-100 border border-background-200 rounded-xl px-5 py-4 cursor-default"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-400">{item.label}</p>
                <p className="text-sm font-medium text-foreground-800">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}